var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowDemandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44098 1.88197C3.86446 1.67023 4.37123 1.71593 4.75 2.00001L6.66667 3.43751L8.58333 2.00001C9.02778 1.66667 9.63889 1.66667 10.0833 2.00001L12 3.43751L13.9167 2.00001C14.3611 1.66667 14.9722 1.66667 15.4167 2.00001L17.3333 3.43751L19.25 2.00001C19.6288 1.71593 20.1355 1.67023 20.559 1.88197C20.9825 2.09371 21.25 2.52654 21.25 3.00001V16C21.25 18.8995 18.8995 21.25 16 21.25H8C5.10051 21.25 2.75 18.8995 2.75 16V3.00001C2.75 2.52654 3.0175 2.09371 3.44098 1.88197ZM5.25 5.50001V16C5.25 17.5188 6.48122 18.75 8 18.75H16C17.5188 18.75 18.75 17.5188 18.75 16V5.50001L18.0833 6.00001C17.6389 6.33334 17.0278 6.33334 16.5833 6.00001L14.6667 4.56251L12.75 6.00001C12.3056 6.33334 11.6944 6.33334 11.25 6.00001L9.33333 4.56251L7.41667 6.00001C6.97222 6.33334 6.36111 6.33334 5.91667 6.00001L5.25 5.50001Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5922 13.7476C13.1312 13.7309 12.707 14.04 12.5952 14.5058C12.4678 15.0371 12.7952 15.5712 13.3265 15.6986L15.3044 16.1731C15.8357 16.3006 16.3698 15.9732 16.4973 15.4418L16.9717 13.4639C17.0992 12.9326 16.7718 12.3985 16.2404 12.2711C15.8492 12.1772 15.4565 12.33 15.2257 12.6292L13.1182 9.33671C12.9561 9.08338 12.6875 8.91757 12.3883 8.88613C12.0892 8.8547 11.792 8.96107 11.5807 9.17517L10.2217 10.5524L8.89784 8.3326C8.61795 7.86331 8.01063 7.70977 7.54134 7.98965C7.07205 8.26953 6.91851 8.87686 7.19839 9.34615L9.17759 12.6647C9.33447 12.9278 9.60434 13.1033 9.9084 13.1402C10.2125 13.177 10.5164 13.0709 10.7315 12.8529L12.1193 11.4465L13.5922 13.7476Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowDemandIcon);
export default __webpack_public_path__ + "static/media/lowDemandIcon.27c96fa4.svg";
export { ForwardRef as ReactComponent };